import React from "react";
import { Helmet } from "react-helmet-async";
import { Radio, MapPin, Users, ShieldCheck } from "lucide-react";
import { TspBreadcrumb } from "../../components/primitives";
import LiveUsersLocationCard from "../dashboard/sections/LiveUsersLocationCard";

export default function TspLiveTrackingPage() {
  return (
    <div className="tsp-page tsp-live-tracking-page">
      <Helmet>
        <title>Live Tracking | TSP</title>
      </Helmet>

      <TspBreadcrumb
        items={[
          { label: "Dashboard", to: "/tsp" },
          { label: "Live Tracking" },
        ]}
      />

      <div className="tsp-page-header tsp-live-tracking-header">
        <div className="tsp-page-header-text">
          <div className="tsp-badge-inline">
            <Radio size={14} className="tsp-live-radio-icon tsp-pulse-dot" />
            <span>Real-Time GPS Tracking</span>
          </div>
          <h1 className="tsp-page-title">Live Users Location</h1>
          <p className="tsp-page-subtitle">
            Monitor real-time GPS locations of Travelling Sankirtan Party (TSP) members, verify live field presence, and view exact coordinates on Google Maps.
          </p>
        </div>
      </div>

      <div className="tsp-live-tracking-content">
        <LiveUsersLocationCard />
      </div>
    </div>
  );
}
